<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/child'
import PageHeader from '@components/page-header'

import BlogsForm from './BlogsForm';
import { CommunicationsTable } from 'coryallen-communications';

export default {
  page: {
    title: 'Blogs',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, PageHeader, BlogsForm, CommunicationsTable },
  data() {
    return {
      title: 'Blogs',
      items: [
        { text: appConfig.title, to: '/', },
        { text: 'Blogs', to: '/blogs', },
        { text: '', active: true, },
      ],
      dsbl_btn: false,

      tabIndex: 0,

      select_version: '',
      isLive: 0,

      loading: true,
      item: [],
      filters: {
        paginate: 1,
        page: 1,
        total: 0,
        getmapping: 'yes',
        wheres: {
          id: this.$route.params.id
        },
        withs: {
          connectedwebsite: {
            total: 0,
            selects: ['id', 'title', 'website_domain', 'website_id'],
          },
          pchildren: {
            total: 0,
          },
          pparents: {
            total: 0,
          }
        },
      },

      loading_versions: true,
      versions: [],

      communications_loading: true,
      communications_filters: {
        paginate: 50,
        page: 1,
        total: 0,
        types: ['Note', 'Activity'],
        only: '',
        onable_id: '',
        onable_type: 'coryallen\\Blogs\\Models\\Blog',
        /* byable_id: '1',
        byable_type: 'App\\User', */
      },

    }
  },
  watch: {
    'item.status': { handler: function(n, o) { this.runIsLive(); }},
    'item.pparents': { handler: function(n, o) { this.runIsLive(); }},
    'item.pchildren': { handler: function(n, o) { this.runIsLive(); }},
  },
  computed: {
    comp_versions: function() {
      var results = [];
      for(var i in this.versions) {
        if(this.versions[i].model_type == 'main') { this.communications_filters.onable_id = this.versions[i].id; }
        results.push({name: this.moment(this.versions[i].created_at).format('lll')+(this.versions[i].user && this.versions[i].user.name ? ' - '+this.versions[i].user.name : '')+(this.versions[i].model_type == 'main' ? ' - (Current)' : (this.versions[i].model_type == 'publ' ? ' - (Published)' : (this.versions[i].model_type == 'save' ? ' - (Save)' : ''))), value: this.versions[i].id});
      }
      return results;
    },
  },
  created() {
    this.tabIndex = parseInt(window.location.hash.replace('#',''), 10);
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;
      this.$http.get('/api/blogs/fetch', {params: this.filters}).then(res => {
        // console.log(res);
        if(res.data.data.length == 1) {
          if(!res.data.data[0].body) { res.data.data[0].body = ''; }
          this.item = res.data.data[0];
          this.title = this.items[2].text = this.item.title;
          this.fetch_versions();
        } else {
          $this.$noty.warning("Content could not be found.");
          this.$router.push('/blogs');
        }
        this.loading = false;
      }).catch(res => { this.popupErrors(res); this.loading = false; });
    },
    fetch_versions() {
      this.loading_versions = true;
      this.$http.get('/api/blogs/fetchVersions', {params: { id: (this.item.model_parent ? this.item.model_parent : this.item.id) } }).then(res => {
        // console.log(res);
        this.versions = res.data;
        this.select_version = JSON.parse(JSON.stringify(this.item.id));
        this.loading_versions = false;
      }).catch(res => { this.loading_versions = false; this.popupErrors(res); });
    },
    update_blog() {
      if(this.dsbl_btn == true) { this.$noty.warning('Disabled'); return; } this.dsbl_btn = true;
      let randomid = 'id'+(Math.random() + 1).toString(36).substring(7);
      var n = new Noty({
        timeout: false,
        modal: true,
        type: 'alert', // alert, success, warning, error, info
        layout: 'center', // top, topLeft, topCenter, topRight, center, centerLeft, centerRight, bottom, bottomLeft, bottomCenter, bottomRight
        closeWith: ['button'], // click, button
        text: 'Save changes to this blog?<br><br>Whenever changes are saved they are always saved to the "Current" version of the blog.<br><br>To save any changes to the live "Published" version of this blog be sure to select the "Publish" button after saving.',
        buttons: [
          Noty.button('<span id="'+randomid+'_spin" class="d-none spinner-border spinner-border-sm"></span> YES', 'btn btn-danger px-4 float-right ml-2', notyres => {
            var btn = document.getElementById(randomid), spin = document.getElementById(randomid+"_spin"), btnno = document.getElementById(randomid+"_no");
            if(btn.disabled) { this.$noty.warning('Disabled'); return; } btn.disabled = btnno.disabled = true; spin.classList.remove("d-none");
            this.$http.put('/api/blogs/update', this.item).then(res => {
              // console.log(res);
              this.dsbl_btn = btn.disabled = btnno.disabled = false; spin.classList.add("d-none");
              this.$noty.success("Changes have been saved");
              this.fetch_versions();
              n.close();
            }).catch(res => { this.popupErrors(res); this.dsbl_btn = btn.disabled = btnno.disabled = false; spin.classList.add("d-none"); });
          }, {id: randomid, 'data-status': 'ok'}),
          Noty.button('CANCEL', 'btn btn-light px-4 mr-2', notyres => {
            n.close();
          }, {id: randomid+'_no', 'data-status': 'ok'}),
        ]
      }).show().on('onClose', () => { this.dsbl_btn = false; });
    },
    publish_blog() {
      if(this.dsbl_btn == true) { this.$noty.warning('Disabled'); return; } this.dsbl_btn = true;
      let randomid = 'id'+(Math.random() + 1).toString(36).substring(7);
      var n = new Noty({
        timeout: false,
        modal: true,
        type: 'alert', // alert, success, warning, error, info
        layout: 'center', // top, topLeft, topCenter, topRight, center, centerLeft, centerRight, bottom, bottomLeft, bottomCenter, bottomRight
        closeWith: ['button'], // click, button
        text: 'Publish this blog?<br><br>This option will publish this blog to the live website. To save any changes made be sure to select the "Save as current" button.',
        buttons: [
          Noty.button('<span id="'+randomid+'_spin" class="d-none spinner-border spinner-border-sm"></span> YES', 'btn btn-danger px-4 float-right ml-2', notyres => {
            var btn = document.getElementById(randomid), spin = document.getElementById(randomid+"_spin"), btnno = document.getElementById(randomid+"_no");
            if(btn.disabled) { this.$noty.warning('Disabled'); return; } btn.disabled = btnno.disabled = true; spin.classList.remove("d-none");
            this.$http.put('/api/blogs/publish', this.item).then(res => {
              // console.log(res);
              this.dsbl_btn = btn.disabled = btnno.disabled = false; spin.classList.add("d-none");
              this.$noty.success("Page has been published");
              this.fetch_versions();
              n.close();
            }).catch(res => { this.popupErrors(res); this.dsbl_btn = btn.disabled = btnno.disabled = false; spin.classList.add("d-none"); });
          }, {id: randomid, 'data-status': 'ok'}),
          Noty.button('CANCEL', 'btn btn-light px-4 mr-2', notyres => {
            n.close();
          }, {id: randomid+'_no', 'data-status': 'ok'}),
        ]
      }).show().on('onClose', () => { this.dsbl_btn = false; });
    },
    delete_blog() {
      if(this.dsbl_btn == true) { this.$noty.warning('Disabled'); return; } this.dsbl_btn = true;
      if(!this.item.id) { this.$noty.warning('ID not found'); this.dsbl_btn = false; return; }
      let randomid = 'id'+(Math.random() + 1).toString(36).substring(7);
      var n = new Noty({
        timeout: false,
        modal: true,
        type: 'alert', // alert, success, warning, error, info
        layout: 'center', // top, topLeft, topCenter, topRight, center, centerLeft, centerRight, bottom, bottomLeft, bottomCenter, bottomRight
        closeWith: ['button'], // click, button
        text: "Are you sure you want to delete this blog?<br><br>This will completely delete the blog and all versions associated with it.",
        buttons: [
          Noty.button('<span id="'+randomid+'_spin" class="d-none spinner-border spinner-border-sm"></span> YES', 'btn btn-danger px-4 float-right ml-2', notyres => {
            var btn = document.getElementById(randomid), spin = document.getElementById(randomid+"_spin"), btnno = document.getElementById(randomid+"_no");
            if(btn.disabled) { this.$noty.warning('Disabled'); return; } btn.disabled = btnno.disabled = true; spin.classList.remove("d-none");
            this.$http.delete('/api/blogs/delete/'+this.item.id, this.item).then(res => {
              // console.log(res);
              this.dsbl_btn = btn.disabled = btnno.disabled = false; spin.classList.add("d-none");
              this.$router.push('/blogs');
              n.close();
            }).catch(res => { this.popupErrors(res); this.dsbl_btn = btn.disabled = btnno.disabled = false; spin.classList.add("d-none"); });
          }, {id: randomid, 'data-status': 'ok'}),
          Noty.button('CANCEL', 'btn btn-light px-4 mr-2', notyres => {
            n.close();
          }, {id: randomid+'_no', 'data-status': 'ok'}),
        ]
      }).show().on('onClose', () => { this.dsbl_btn = false; });
    },
    load_blog() {
      if(this.dsbl_btn == true) { this.$noty.warning('Disabled'); return; } this.dsbl_btn = true;
      let randomid = 'id'+(Math.random() + 1).toString(36).substring(7);
      var n = new Noty({
        timeout: false,
        modal: true,
        type: 'alert', // alert, success, warning, error, info
        layout: 'center', // top, topLeft, topCenter, topRight, center, centerLeft, centerRight, bottom, bottomLeft, bottomCenter, bottomRight
        closeWith: ['button'], // click, button
        text: "Are you sure you want to load this version?<br><br>Be sure any changes you would like saved, have been saved before continuing.",
        buttons: [
          Noty.button('<span id="'+randomid+'_spin" class="d-none spinner-border spinner-border-sm"></span> YES', 'btn btn-danger px-4 float-right ml-2', notyres => {
            var btn = document.getElementById(randomid), spin = document.getElementById(randomid+"_spin"), btnno = document.getElementById(randomid+"_no");
            if(btn.disabled) { this.$noty.warning('Disabled'); return; } btn.disabled = btnno.disabled = true; spin.classList.remove("d-none");
            this.$router.push('/blogs/'+this.select_version);
            this.dsbl_btn = btn.disabled = btnno.disabled = false; spin.classList.add("d-none");
            n.close();
          }, {id: randomid, 'data-status': 'ok'}),
          Noty.button('CANCEL', 'btn btn-light px-4 mr-2', notyres => {
            n.close();
          }, {id: randomid+'_no', 'data-status': 'ok'}),
        ]
      }).show().on('onClose', () => { this.dsbl_btn = false; });
    },
    runIsLive() {
      if(this.item.model_type == 'publ' && this.item.status == 1) {
        this.isLive = true; return;
      } else if(this.item.pchildren && this.item.pchildren.length) {
        for(var i in this.item.pchildren) { if(this.item.pchildren[i].model_type == 'publ' && this.item.pchildren[i].status) { this.isLive = true; return; } }
      } else if(this.item.pparents && this.item.pparents.length) {
        for(var i in this.item.pparents) { if(this.item.pparents[i].model_type == 'publ' && this.item.pparents[i].status) { this.isLive = true; return; } }
      }
      this.isLive = false; return;
    },
    viewCount() {
      if(this.item.model_type == 'publ' && this.item.view_count) {
        return this.item.view_count;
      } else if(this.item.pchildren && this.item.pchildren.length) {
        for(var i in this.item.pchildren) { if(this.item.pchildren[i].model_type == 'publ' && this.item.pchildren[i].view_count) { return this.item.pchildren[i].view_count;} }
      } else if(this.item.pparents && this.item.pparents.length) {
        for(var i in this.item.pparents) { if(this.item.pparents[i].model_type == 'publ' && this.item.pparents[i].view_count) { return this.item.pparents[i].view_count;} }
      }
      return 0;
    },
  }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <b-tabs class="nav-bordered header-nav hide-content" lazy v-model="tabIndex">
      <b-tab><template v-slot:title><span class="spinner-border spinner-border-sm" v-if="loading"></span> Details</template></b-tab>
      <b-tab><template v-slot:title><span class="spinner-border spinner-border-sm" v-if="communications_loading"></span> Notes & Activities</template></b-tab>
    </b-tabs>

    <div v-if="item.id">

      <div v-show="tabIndex == 0">
        <div class="row mt-4 set-sm-375">
          <div class="col-lg-4">
            <article class="card overflow-hidden mb-4 border _box-shadow-0-1-4-b-2" data-aos="fade-zoom-in">
              <div class="">
                <img v-if="item.thumbnail" :src="formatImage(item.thumbnail)" :alt="item['title']" class="img-fluid w-100 mx-auto d-block">
                <img v-else src="@assets/images/no-image.jpg" :alt="item['title']" class="img-fluid w-100 mx-auto d-block">
              </div>
              <div class="p-3 mx-3 bg-white rounded _m-t-n-15">
                <p class="text-primary text-center mb-1">
                  <span v-for="(zet, zet_i) in item.categories" :key="zet_i">{{zet}}<span v-if="(zet_i + 1) < item.categories.length">, </span></span>
                </p>
                <h1 class="h5 text-center">{{ item['title'] }}</h1>
                <hr class="my-3">
                <div class="_h-m-150 overflow-hidden" v-html="item['content']"></div>
                <div class="position-relative text-center py-3">
                  <a class="btn btn-block btn-primary">Read More <span class="border-left mx-3"></span><Icon icon="ri:arrow-right-line" height="20"></Icon></a>
                </div>
                <hr class="mt-0 mb-3">
                <div class="text-muted font-italic small">
                  By {{ item['posted_by'] }}
                  On {{ moment(item.posted_on).format('ll') }}
                </div>
              </div>
            </article>
            <div class="card-box">
              <h5 class="section-header mb-3"><Icon icon="ri:book-2-line" /> About :</h5>
              <div class="table-responsive">
                <table class="table table-sm table-px-0">
                  <tbody>
                    <tr v-tippy content="A page is live when there is a published version of the page with the Live setting set to Yes."><th class="border-0"><label>Live <Icon icon="ri:question-line"></Icon> :</label></th><td class="border-0 small"><div v-if="isLive" class="alert alert-success small mb-0 px-2 py-1">Yes</div><div v-else class="alert alert-danger small mb-0 px-2 py-1">No</div></td></tr>
                    <tr><th><label>Page views :</label></th><td class="small">{{viewCount()}}</td></tr>
                    <tr><th><label>Model type :</label></th><td class="small">{{item.model_type}}</td></tr>
                    <tr><th><label>Updated on :</label></th><td class="small" v-tippy :content="moment(item.updated_at).format('lll')">{{moment(item.updated_at).fromNow()}}</td></tr>
                    <tr><th><label>Created on :</label></th><td class="small" v-tippy :content="moment(item.created_at).format('lll')">{{moment(item.created_at).fromNow()}}</td></tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="card-box p-0">
              <div class="card-header bg-primary text-white">Search preview</div>
              <div class="p-3 small font-weight-normal" style="font-family:Roboto,arial,sans-serif">
                <div v-if="item.slug">{{ (item.connectedwebsite && item.connectedwebsite.website_domain ? item.connectedwebsite.website_domain+'/' : app_url+'/') }}{{item.slug.replace(/\//, "")}}</div>
                <div v-if="item.meta_title" class="m-0 _f-s-18" style="color:#1a0dab;">{{ (item.meta_title ? item.meta_title.substring(0, 60)+' - ' : '')+(item.connectedwebsite && item.connectedwebsite.title ? item.connectedwebsite.title : app_name) }}<span v-if="item.meta_title.length > 60">...</span></div>
                <div v-if="item.meta_description">{{item.meta_description.substring(0, 160)}}<span v-if="item.meta_description.length > 160">...</span></div>
              </div>
            </div>
            <div class="card-box p-0">
              <div class="card-header bg-primary text-white">Social/Mobile preview</div>
              <div class="bg-light p-3 pl-5">
                <div class="bg-white p-3 rounded small font-weight-normal" style="font-family:Roboto,arial,sans-serif;">
                  <div v-if="item.meta_image" class="mb-2"><img class="card-img-top" :src="formatImage(item.meta_image)"></div>
                  <div v-if="item.slug" class="mb-1">{{ (item.connectedwebsite && item.connectedwebsite.website_domain ? item.connectedwebsite.website_domain+'/' : app_url+'/') }}{{item.slug.replace(/\//, "")}}</div>
                  <h6 v-if="item.meta_title" class="mb-1">{{ (item.meta_title ? item.meta_title.substring(0, 60)+' - ' : '')+(item.connectedwebsite && item.connectedwebsite.title ? item.connectedwebsite.title : app_name) }}</h6>
                  <div v-if="item.meta_description" class="text-nowrap text-truncate">{{item.meta_description}}</div>
                </div>
              </div>
            </div>
            <button type="button" class="btn btn-block btn-outline-danger" @click="delete_blog" :disabled="dsbl_btn"><Icon icon="ri:delete-bin-7-line" /> Delete Blog</button>
          </div>
          <div class="col-lg-8">
            <div class="card-box">
              <h5 class="section-header mb-3"><Icon icon="ri:book-2-line"></Icon> Versions :</h5>
              <div class="small mb-3">Use this drop down if you would like to load previous saves or published versions of this page. Be aware that when another version is loaded then saved it will replace the (Current) version of this page.</div>
              <div class="input-group mb-3">
                <select class="form-control" v-model="select_version">
                  <option v-for="(ver, ver_i) in comp_versions" :key="ver_i" :value="ver.value">{{ver.name}}</option>
                </select>
                <div class="input-group-append">
                  <button type="button" class="btn btn-block btn-primary" @click="load_blog"><Icon icon="ri:file-copy-2-line" /> Load</button>
                </div>
              </div>
            </div>
            <div class="card-box">
              <b-form @submit.prevent="update_blog">
                <BlogsForm :item="item"></BlogsForm>
                <div class="border-top border-light mt-5 pt-3 text-right">
                  <button type="button" class="btn btn-purple ml-3" @click="publish_blog" :disabled="dsbl_btn"><Icon icon="ri:newspaper-line" /> Publish</button>
                  <button type="submit" class="btn btn-success ml-3" :disabled="dsbl_btn"><Icon icon="ri:save-line" /> Save as current</button>
                  <div class="clearfix"></div>
                </div>
              </b-form>
            </div>
          </div>
        </div>
      </div>
      
      <div v-show="tabIndex == 1">
        <div v-if="communications_filters.onable_id" class="mt-3">
          <CommunicationsTable ref="CommunicationsTable" :filters="communications_filters" :user="user" :name="'title'" @loadchange="(e) => {communications_loading = e}"></CommunicationsTable>
        </div>
      </div>
  

    </div>
  </Layout>
</template>
